<script lang="ts">
  import { Chart, Svg, Axis, Bars, Tooltip, Highlight } from 'layerchart';
  import { scaleBand } from 'd3-scale';
  import { format } from 'd3-format'; // 1. 引入 d3-format 用于格式化刻度

  interface Props {
    trafficTrends: Array<{ hour: string; pv: number; uv: number }>;
    t: (path: string) => string;
  }

  let { trafficTrends = [], t }: Props = $props();

  // 2. 动态计算 y 轴的最大上限，确保最小不低于 10
  let yMax = $derived.by(() => {
    if (!trafficTrends || trafficTrends.length === 0) return 10;
    const maxVal = Math.max(...trafficTrends.flatMap(d => [d.pv || 0, d.uv || 0]));
    return Math.max(maxVal, 10);
  });
</script>

<div class="rounded-xl border bg-card p-5 shadow-sm flex flex-col">
  <div class="flex items-center justify-between mb-4">
    <div>
      <h3 class="text-sm font-semibold">{t('dashboard.charts.traffic_trend_title')}</h3>
      <p class="text-xs text-muted-foreground">{t('dashboard.charts.traffic_trend_desc')}</p>
    </div>
    <div class="flex items-center gap-3 text-xs">
      <span class="flex items-center gap-1"><span class="size-2 rounded-full bg-primary"></span> {t('dashboard.kpi.pv_label')}</span>
      <span class="flex items-center gap-1"><span class="size-2 rounded-full bg-muted-foreground"></span> {t('dashboard.kpi.uv_label')}</span>
    </div>
  </div>
  
  <div class="h-56 w-full relative">
    {#if trafficTrends && trafficTrends.length > 0}
      <Chart
        data={trafficTrends}
        x="hour"
        xScale={scaleBand().padding(0.2)}
        y={['pv', 'uv']}
        yDomain={[0, yMax]}
        padding={{ top: 10, bottom: 24, left: 28, right: 10 }}
        tooltip={{ mode: 'band' }}
      >
        <Svg>
          <Axis placement="bottom" grid class="text-[10px] text-muted-foreground" />
          
          <!-- 4. 给 y 轴指定 format，用 "d" 强制保留整型，并设置 ticks 限制分割数量 -->
          <Axis 
            placement="left" 
            grid 
            ticks={5}
            format={format('d')} 
            class="text-[10px] text-muted-foreground" 
          />

          <Bars y="uv" class="fill-muted-foreground/40" />
          <Bars y="pv" class="fill-primary/80" />

          <Highlight bar class="fill-primary/10" />
        </Svg>

        <Tooltip.Root>
          {#snippet children({ data })}
            {#if data}
              <Tooltip.Header>{data.hour ?? ''} {t('dashboard.charts.detail_suffix')}</Tooltip.Header>
              <Tooltip.List>
                <Tooltip.Item label={t('dashboard.charts.pv_item')} value={data.pv ?? 0} class="text-primary" />
                <Tooltip.Item label={t('dashboard.charts.uv_item')} value={data.uv ?? 0} class="text-muted-foreground" />
              </Tooltip.List>
            {/if}
          {/snippet}
        </Tooltip.Root>
      </Chart>
    {:else}
      <div class="flex h-full items-center justify-center text-xs text-muted-foreground">
        {t('dashboard.charts.no_traffic_data')}
      </div>
    {/if}
  </div>
</div>